/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "OrderTickets": {
                                "fields": {
                                  "namingType": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets.OrderTicketNamingType",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "CUSTOM_NAME"
                                    }
                                  }
                                },
                                "nested": {
                                  "OrderTicketNamingType": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "AUTOMATIC_NUMBERING": 1,
                                      "CUSTOM_NAME": 2,
                                      "AUTOMATIC_NUMBERING_INCLUDE_OPEN_TICKETS": 3,
                                      "NO_TICKET_IDENTIFIER": 4,
                                      "ALWAYS_PROMPT_FOR_CUSTOM_NAME": 5
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.OrderTickets && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.OrderTickets?.nested?.OrderTicketNamingType) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE OrderTickets @ squareup/devicesettings/profiles/v2/model/settings/common/order_tickets.proto at 17:1
 */
export const OrderTickets = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets');
fixType(OrderTickets);
Builder.createAndAttachToType(OrderTickets);
/**
 * SOURCE OrderTicketNamingType @ squareup/devicesettings/profiles/v2/model/settings/common/order_tickets.proto at 19:3
 */
OrderTickets.OrderTicketNamingType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets.OrderTicketNamingType').values;